import { Record } from 'immutable';

const AdjustmentTypeRecord = Record({
  id: null,
  name: null,
  description: null,
  credit: null,
  debit: null
});

export class AdjustmentType extends AdjustmentTypeRecord {
    id: number;
    name: string;
    description: string;
    credit: boolean;
    debit: boolean;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/adjustment-type.ts